import UnauthenticatedPage from "../pages/Unauthenticated";

export function meta() {
  return [
    { title: "ePaper" },
    { name: "robots", content: "noindex, nofollow" },
  ];
}

export default function UnauthenticatedRoute() {
  return <UnauthenticatedPage />;
}
